import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-risultati-ricerca',
	templateUrl: './risultati-ricerca.component.html',
})
export class RisultatiRicercaComponent implements OnInit {
	constructor(private route: ActivatedRoute) {}

	query = '';

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			if (params.q) {
				this.query = params.q;
			}
		});
	}
}
